import React from 'react';
import ReactDOM from 'react-dom';
import 'react-select/dist/react-select.css';

import MarriageLawSearch from '../marriage_laws/marriage_law_search';

document.addEventListener("DOMContentLoaded", () => {
  ReactDOM.render(
    <MarriageLawSearch />,
    document.getElementById('state-search')
  );
});
